import(/* webpackMode: "eager" */ "/vercel/path0/app/programas/page.tsx");
